module.exports = __webpack_public_path__ + "media/images/icon_a9-2ef3be20a7b5282015b1bd9885777156.png";